



















































































































































































































import { TemplateTokenConfig } from "@/lib/configuration/template-token.configuration";
import { AppContextEnum } from "@/lib/enum/appContext.enum";
import { LanguageCodeEnum } from "@/lib/enum/language-code.enum";
import { MessageContentFormatEnum } from "@/lib/enum/templateEnums/messageContentFormat.enum";
import { MessageMedium } from "@/lib/enum/templateEnums/messageMedium.enum";
import { ITemplateContext, ITemplateExtendedContext } from "@/lib/interfaces/template/templateContext.interface";
import { getNestedObjectValues, setNestedObjectValues } from "@/lib/objectPath-helper";
import { emailRule } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { renderTemplate } from "@/lib/utility/renderTemplate";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IPageFilterElement } from "@/models/page-filter-element.entity";
import { PartnerMessage } from "@/models/partner-message.entity";
import { PartnerEntity } from "@/models/partnerEntity";
import { IReference } from "@/models/reference.entity";
import { ISignDocument, SignDocument } from "@/models/sign-document.entity";
import { Ticket } from "@/models/ticket.entity";
import { IUser } from "@/models/user.entity";
import {
  MrfiktivAdminTemplateViewModelGen,
  MrfiktivCreateMessageDtoGen,
  MrfiktivMessageAttachmentGen,
  MrfiktivPartnerTemplateViewModelGen,
  MrfiktivSettingPartnerInternalViewModelGen,
  MrfiktivSettingViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { ThgAdminTemplateViewModelGen, ThgPartnerTemplateViewModelGen } from "@/services/thg/v1/data-contracts";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { ConfigModule } from "@/store/modules/config";
import { UserModule } from "@/store/modules/me-user.store";
import { SettingModule } from "@/store/modules/setting.store";
import DocumentSelectionSimpleDialog from "@/views/sign/DocumentSelectionSimpleDialog.vue";
import { debounce } from "debounce";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import Card from "../utility/Card.vue";
import ComboBox from "../utility/ComboBox.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import Debug from "../utility/Debug.vue";
import Tooltip from "../utility/tooltip.vue";
import TemplateEditor from "./TemplateEditor.vue";
import TemplateEditorActionDivider from "./TemplateEditorActionDivider.vue";
import TemplateSelectionDialog from "./TemplateSelectionDialog.vue";
import TicketCreateCheckbox from "./TicketCreateCheckbox.vue";
import { formatBytes } from "@/lib/utility/file-helper";
import { $t } from "@/lib/utility/t";

@Component({
  components: {
    Card,
    ComboBox,
    Debug,
    ConfirmActionDialog,
    DocumentSelectionSimpleDialog,
    TemplateEditor,
    TemplateSelectionDialog,
    TemplateEditorActionDivider,
    Tooltip,
    TicketCreateCheckbox
  },
  filters: { formatBytes }
})
export default class TemplateCard extends mixins(PermissionMixin) {
  readonly MessageContentFormatEnum = MessageContentFormatEnum;

  /**
   * 8 MB max total attachment size
   */
  private readonly MAX_TOTAL_ATTACHMENT_BYTES = 8 * 1024 * 1024;

  @Prop()
  partnerId?: string;

  @Prop()
  from!: PartnerEntity[];

  @Prop({ default: false })
  isTicketEnabled?: boolean;

  @Prop()
  context!: ITemplateContext;

  @Prop()
  loadContext?: () => Promise<ITemplateContext>;

  @Prop()
  to!: string[];

  // If undefined, all "to"s are prefilled
  @Prop()
  prefillTo?: string[];

  @Prop({ default: false })
  isCustomSenderSelection?: boolean;

  @Prop()
  isEditorMobile?: boolean;

  @Prop()
  refs!: IReference[];

  @Prop({ type: Boolean, default: true })
  isAttachmentEnabled!: boolean;

  @Prop({ default: () => [] })
  attachmentFileFilters!: IPageFilterElement[];

  attachmentMenu = false;

  get isMobile() {
    if (this.isEditorMobile) {
      return true;
    }
    if (this.$vuetify.breakpoint.mdAndDown) {
      return true;
    }
    return false;
  }

  get refKey(): string | undefined {
    if (this.refs && this.refs.length > 0) {
      return this.refs[0].refId;
    }

    return undefined;
  }

  get portalContext() {
    return ConfigModule.appContext === AppContextEnum.REPORT_PORTAL;
  }

  template: ThgAdminTemplateViewModelGen | ThgPartnerTemplateViewModelGen = {
    key: "",
    content: {
      subject: "",
      body: "",
      tokens: []
    },
    meta: {
      description: "",
      categories: [],
      editor: "tiptap",
      contentFormat: "html",
      language: LanguageCodeEnum.DE,
      title: ""
    },
    timestamp: { created: new Date().toString(), lastModified: new Date().toString() },
    isAdminTemplate: false
  };

  reminderDate: string | null = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
  createReminder = false;

  customTokenDialog = false;
  documentSelectDialog = false;

  selectedReceivers: string[] = this.to;
  selectedSender = this.from?.length > 0 ? this.from[0].companyName : "";

  renderedBody = "";
  renderedSubject = "";

  loading = false;

  isValid = false;
  isReceiverSelectionValid = false;
  isSenderSelectionValid = false;

  problems: string[] = [];

  extendedContext: ITemplateExtendedContext = {};

  attachments: ISignDocument[] = [];
  selected: ISignDocument[] = [];

  /**
   * this key is incremented whenever the template is regenerated.
   * it forces the template editor to rerender to be responsive to changes
   */
  k = 0;

  /**
   * How long to wait for changes before search input is updated
   */
  filterDebounceTimeout = 300;

  get isTokenWithoutValue() {
    for (const token of this.template.content.tokens) {
      if (!this.getValue(token)) {
        return true;
      }
    }
    return false;
  }

  get hasTokens() {
    return this.template.content.tokens.length;
  }

  get references() {
    return this.refs || [];
  }

  get templateEditorOffset() {
    if (this.$vuetify.breakpoint.xsOnly) {
      return 190;
    }
    return 150;
  }

  get receiverMailRules() {
    return [emailRule(" ")];
  }

  get textRules(): any {
    return [requiredRule()];
  }

  get allFormsValid() {
    return this.isValid && this.isReceiverSelectionValid;
  }

  get senderNames() {
    return this.from?.map(s => s.companyName);
  }

  get selectedSenderId() {
    const sender = this.from?.find(s => s.companyName === this.selectedSender);

    return sender?._id || "";
  }

  get settingTokens() {
    return this.template.content.tokens.filter((c: string) => c.split(".")[0] === TemplateTokenConfig.settingCategory);
  }

  get customTokens() {
    return this.template.content.tokens.filter((c: string) => c.split(".")[0] === TemplateTokenConfig.customCategory);
  }

  async mounted() {
    this.loading = true;

    // for some reason this.template was undefined when mounting
    this.template = {
      key: "",
      content: {
        subject: "",
        body: "",
        tokens: []
      },
      meta: {
        description: "",
        categories: [],
        editor: "tiptap",
        contentFormat: "html",
        language: LanguageCodeEnum.DE,
        title: ""
      },
      timestamp: { created: new Date().toString(), lastModified: new Date().toString() },
      isAdminTemplate: false
    };

    await this.setContext();
    this.generateTemplate();

    this.loading = false;
  }

  @Watch("selectedReceivers")
  @Watch("isValid")
  @Watch("renderedBody")
  isValidWatcher() {
    this.$emit("isValid", this.isValid && this.renderedBody.length > 0 && this.selectedReceivers?.length > 0);
  }

  getLabel(tokenPath: string) {
    const translationPrefix = "components.template.editor.placeholder.path";
    const translation = this.$t(`${translationPrefix}.${tokenPath}`).toString();
    if (translation.startsWith(translationPrefix)) {
      return tokenPath;
    }
    return translation;
  }

  getValue(tokenPath: string) {
    return getNestedObjectValues(this.extendedContext, tokenPath);
  }

  setValue(tokenPath: string, value: string) {
    return setNestedObjectValues(this.extendedContext, tokenPath, value);
  }

  /**
   * Sets the template to loading
   *
   * @param loading
   */
  setLoading(loading: boolean) {
    this.loading = loading;
  }

  changeReceiverSelection(selectedReceivers: string[]) {
    this.selectedReceivers = selectedReceivers;
  }

  changeIsReceiverSelectionValid(isValid: boolean) {
    this.isReceiverSelectionValid = isValid;
  }

  changeSenderSelection(selectedSender: string) {
    this.selectedSender = selectedSender ? selectedSender : "";
  }

  changeIsSenderSelectionValid(isValid: boolean) {
    this.isSenderSelectionValid = isValid;
  }

  debounceInput = debounce(
    (v: any, customTokenKey: string) => this.handleCustomContextChange(v, customTokenKey),
    this.filterDebounceTimeout,
    false
  );

  get my(): IUser {
    return UserModule.user;
  }

  get myUserId() {
    return UserModule.userId;
  }

  async setContext() {
    const context = (await this.getContext()) || {};
    this.extendedContext = { ...context, custom: {}, my: this.my };
  }

  async getContext() {
    const context = this.context;
    if (context) {
      return context;
    }

    const loadContext = this.loadContext;
    if (loadContext) {
      try {
        const context = await loadContext();

        return context;
      } catch (e) {
        this.$log.error(e);
        this.$toast.error((e as any).message);
      }
    }
    this.$log.error("either context or load context must be given");
  }

  /**
   * Add a key value to the extended context manually from outside
   * @param key
   * @param value
   */
  extendCustomExtendedContext(key: string, value: string) {
    // this.extendedContext = { ...this.extendedContext, custom: { ...this.extendedContext.custom, [key]: value } };
    this.debounceInput(value, key);
  }

  async buildExtendedContext() {
    this.$log.debug("EXTENDED CONTEXT CHANGED");
    this.addCustomToContext();
    this.$log.debug("ADDED CUSTOM TOKENS");
    await this.addSettingsToContext();
    this.$log.debug("ADDED SETTINGS TO CONTEXT");
  }

  async loadSetting(key: string) {
    let setting: MrfiktivSettingViewModelGen | MrfiktivSettingPartnerInternalViewModelGen | undefined;

    if (this.partnerId) {
      setting = await SettingModule.getSettingByKey({ key: key, partnerId: this.partnerId });

      if (!setting) {
        this.problems.push(`Setting ${key} not found`);
      }
      if (setting?.isEncrypted) {
        this.problems.push(`Setting ${key} encrypted`);
      }
    } else {
      try {
        setting = await SettingModule.getAdminSettingByKey(key);
        if (setting?.isEncrypted) {
          this.problems.push(`Setting ${key} encrypted`);
        }
      } catch (e) {
        this.problems.push(`Setting ${key} not found`);
      }
    }

    return setting?.value;
  }

  handleCustomContextChange(v: any, customTokenKey: string) {
    this.setValue(customTokenKey, v);

    this.generateTemplate();
  }

  addCustomToContext() {
    const settingContext: Record<string, string> = {};

    this.customTokens.forEach(t => {
      const key = t.split(".")[1];
      settingContext[key] = `${key}`;
    });

    this.extendedContext.custom = settingContext;
  }

  async addSettingsToContext() {
    const settingsAsync: Promise<{ key: string; value: string | undefined }>[] = this.settingTokens
      .map(st => st.split(".")[1])
      .map(async key => {
        return {
          key: key,
          value: await this.loadSetting(key)
        };
      });

    const settings = await Promise.all(settingsAsync);

    const settingContext: Record<string, string> = {};
    settings.forEach(s => (settingContext[s.key] = s.value || ""));

    this.extendedContext.setting = settingContext;
  }

  generateTemplate() {
    const input = this.extendedContext;

    this.renderedSubject = renderTemplate(this.template.content.subject, input);
    this.renderedBody = renderTemplate(this.template.content.body, input);

    this.k++;
  }

  setExtendedContext(extendedContext: ITemplateExtendedContext) {
    this.extendedContext = extendedContext;
    this.generateTemplate();
  }

  async setTemplate(template: MrfiktivPartnerTemplateViewModelGen | MrfiktivAdminTemplateViewModelGen) {
    this.loading = true;
    this.template = template;
    await this.buildExtendedContext();
    this.generateTemplate();
    this.loading = false;
  }

  assertMailInformation() {
    const errors: string[] = [];
    const missingErrors: string[] = [];
    if (!this.selectedSenderId) {
      missingErrors.push(this.$t("components.template.detail.errors.sender").toString());
    }
    if (!this.selectedReceivers?.length) {
      missingErrors.push(this.$t("components.template.detail.errors.receiver").toString());
    }
    if (!this.renderedSubject) {
      missingErrors.push(this.$t("components.template.detail.errors.subject").toString());
    }
    if (!this.renderedBody) {
      missingErrors.push(this.$t("components.template.detail.errors.body").toString());
    }
    if (this.attachments && this.attachments.length && this.attachments.some(a => a.isLoadingInternal)) {
      missingErrors.push(this.$t("components.template.detail.errors.attachment").toString());
    }
    if (missingErrors.length) {
      errors.push(missingErrors.join(", ") + " " + this.$t("components.template.detail.errors.missing").toString());
    }

    if (this.selectedReceivers.length)
      for (const receiver of this.selectedReceivers) {
        const rule = emailRule()(receiver);
        if (rule && rule !== true) {
          errors.push(rule);
        }
      }

    if (errors.length) {
      throw new Error(errors.join(", "));
    }
  }

  async send() {
    try {
      this.assertMailInformation();
      this.loading = true;
      const mrfiktivCreateMessageDtoGen: MrfiktivCreateMessageDtoGen[] = [];

      const attachments: MrfiktivMessageAttachmentGen[] | undefined = this.attachments.length
        ? this.attachments.map(a => ({
            name: a.name,
            type: "application/pdf",
            size: a.size || 0,
            ref: {
              refId: a.id || "",
              refType: ResourceEnum.DOCUMENT
            }
          }))
        : undefined;

      for (const receiver of this.selectedReceivers) {
        mrfiktivCreateMessageDtoGen.push({
          to: receiver,
          content: {
            subject: this.renderedSubject,
            body: this.renderedBody
          },
          attachments: attachments,
          meta: {
            contentFormat: MessageContentFormatEnum.HTML,
            medium: MessageMedium.EMAIL
          }
        });
      }

      const promises = [];
      for (const dto of mrfiktivCreateMessageDtoGen) {
        promises.push(new PartnerMessage({ partnerId: this.selectedSenderId, ...dto, refs: this.refs ?? [] }).create());
      }
      const messages = await Promise.all(promises);

      if (this.isTicketEnabled && this.canCreateTicket && this.createReminder) {
        const ticketRefs = this.refs ? [...this.refs] : [];
        for (const message of messages) {
          ticketRefs.push({ refId: message.id, refType: ResourceEnum.MESSAGE });
        }

        const ticket = new Ticket({
          partnerId: this.partnerId,
          title: this.renderedSubject,
          refs: ticketRefs,
          assignees: [this.myUserId]
        });

        ticket.due = this.reminderDate ? new Date(this.reminderDate).toISOString() : undefined;

        await ticket.create();
      }

      this.$toast.success(this.$t("components.template.dialog.preview.sentConfirmation"));

      this.template.content.subject = "";
      this.template.content.body = "";
      this.attachments = [];
      this.generateTemplate();

      this.$emit("sent", messages);

      return messages;
    } catch (e) {
      this.$log.error(e);
      this.$toast.error((e as any).message);
    } finally {
      this.loading = false;
    }
  }

  onPickLocalFile() {
    this.attachmentMenu = false;
    (this.$refs.localFileInput as HTMLInputElement).click();
  }

  async onLocalFilesSelected(e: Event) {
    const input = e.target as HTMLInputElement;
    if (!input.files) return;

    const files = Array.from(input.files);
    const newTotal = files.reduce((sum, f) => sum + f.size, 0);

    if (!this.canAddAttachments(newTotal)) {
      input.value = "";
      return;
    }

    const newItems = files.map(
      f =>
        new SignDocument({
          name: f.name,
          title: f.name,
          isTemplate: false,
          folder: "/attachments/",
          refs: this.refs,
          file: f,
          partnerId: this.partnerId
        })
    );
    this.attachments.push(...newItems);

    for (const item of newItems) {
      item.create();
    }

    input.value = "";
  }

  getTotalAttachmentBytes() {
    return this.attachments.reduce((sum, a) => sum + (a.size || 0), 0);
  }

  removeAttachment(i: number) {
    this.attachments.splice(i, 1);
  }

  /**
   * Check if new attachments can be added without exceeding max total size
   * @param newBytes
   */
  canAddAttachments(newBytes: number): boolean {
    const currentTotal = this.getTotalAttachmentBytes();
    const maxMb = (this.MAX_TOTAL_ATTACHMENT_BYTES / (1024 * 1024)).toFixed(0);

    if (currentTotal + newBytes > this.MAX_TOTAL_ATTACHMENT_BYTES) {
      this.$toast.error($t("components.template.detail.errors.toLarge", { maxMb }).toString());
      return false;
    }

    return true;
  }

  attachDocuments(documents: ISignDocument[]) {
    const invalidDocs = documents.filter(d => !d.id);
    if (invalidDocs.length > 0) {
      this.$toast.error($t("components.template.detail.errors.missingId").toString());
      return;
    }

    const existingIds = new Set(this.attachments.map(a => a.id).filter((id): id is string => !!id));

    const uniqueNewDocs: ISignDocument[] = [];
    let droppedCount = 0;

    for (const d of documents) {
      if (!d.id) {
        this.$toast.error($t("components.template.detail.errors.missingId").toString());
        return;
      }
      if (existingIds.has(d.id)) {
        droppedCount++;
        continue;
      }
      uniqueNewDocs.push(d);
    }

    if (droppedCount > 0) {
      this.$toast.info($t("components.template.detail.errors.duplicate", { droppedCount }).toString());
    }

    const newTotal = uniqueNewDocs.reduce((sum, d) => sum + (d.size || 0), 0);

    if (!this.canAddAttachments(newTotal)) {
      return;
    }

    this.attachments.push(...uniqueNewDocs);
    this.selected = [];
  }
}
